<template>
    <div class="grid grid-cols-4 gap-16">
        <div class="col-span-3">
            <div class="space-y-8">
                <div v-for="block in blocks.filter(b => !b.hidden)">
                    <div
                        class="cursor-pointer flex justify-between items-center p-8 bg-primary-5 border rounded-4"
                        @click="toggle(block.name)"
                    >
                        <p class="text-body font-semibold">{{ block.title }}</p>
                        <svg-icon
                            :type="toggled === block.name ? 'keyboard-arrow-up' : 'keyboard-arrow-down'"
                            size="24"
                        />
                    </div>
                    <component
                        v-if="toggled === block.name"
                        :is="block.component"
                        class="p-12"
                    />
                </div>
            </div>
        </div>

        <div class="col-span-1">
            <slot name="basket"></slot>
        </div>
    </div>
</template>

<script>
import SvgIcon from "../ui/SvgIcon.vue";
import {mapState} from "pinia";
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../state/store';
import {useMultiPostingStore} from '../../state/modules/multiPosting';
import Wysiwyg from "../forms/Wysiwyg.vue";
import {getCountriesSelectOptions} from "../../../shared/helpers";
import Currency from "../Currency.vue";
import Job from "../../models/Job";
import TargetGroup from "./review/TargetGroup.vue";
import PostingDetails from "./review/PostingDetails.vue";
import Channels from "./review/Channels.vue";
import Analytics from "./review/Analytics.vue";

export default {
    name: 'CampaignFormReview',
    components: {Currency, Wysiwyg, SvgIcon, TargetGroup},
    data() {
        return {
            toggled: null,
        }
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany']),
        ...mapState(useMultiPostingStore, ['form', 'selectedItems', 'campaign']),
        blocks() {
            return [
                {
                    title: this.$t('multi-posting.campaigns.form.target_group.title'),
                    name: 'target',
                    component: TargetGroup,
                    hidden: this.onlySocialChannels
                },
                {
                    title: this.$t('multi-posting.campaigns.form.posting_details.title'),
                    name: 'posting',
                    component: PostingDetails,
                },
                {
                    title: this.$t('multi-posting.channels.title'),
                    name: 'channels',
                    component: Channels,
                },
                {
                    title: this.$t('analytics.title'),
                    name: 'analytics',
                    component: Analytics,
                    hidden: this.form?.editable || this.campaign.editable,
                }
            ]
        },
        job() {
            return useRepo(Job).find(this.form.jobId)
        },
        onlySocialChannels() {
            return this.selectedItems.every(x => x.type === 'socialChannel');
        }
    },
    methods: {
        toggle(section) {
            if (this.toggled === section) this.toggled = null;
            else this.toggled = section;
        }
    },
    beforeMount() {
        if (!this.form?.editable && !this.campaign.draft_mode && this.campaign.status !== 'in progress') {
            this.toggled = 'analytics';
        } else if (this.onlySocialChannels) {
            this.toggled = 'posting';
        } else {
            this.toggled = 'target';
        }
    }
}
</script>
